module.exports = __webpack_public_path__ + "img/Ntabi.0920e9fe.png";